import { SettingService } from 'src/app/system-common/services/setting.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FinanceServiceHandler } from './finance.service.handler';

@Injectable({
  providedIn: 'root',
})
export class FinanceService extends FinanceServiceHandler {
  // getOutputPreferences(ref_id: any) {
  //   throw new Error('Method not implemented.');
  // }
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }
}
